import apiClient from '../client'
import type { NoticeSettingItem, NoticeSettingUpsert } from '../noticeSettings/types'

const mgmtBase = (municipalityId: number) => `/api/municipalities/${municipalityId}/privacy-policy-settings`

export const privacyPolicySettingsApi = {
  listForMyMunicipality() {
    return apiClient.get<NoticeSettingItem[]>('/api/admin/privacy-policy-settings')
  },
  saveForMyMunicipality(body: NoticeSettingUpsert) {
    return apiClient.put<NoticeSettingItem>('/api/admin/privacy-policy-settings', body, { _silent: true })
  },
  listForManagement(municipalityId: number) {
    return apiClient.get<NoticeSettingItem[]>(mgmtBase(municipalityId))
  },
  saveForManagement(municipalityId: number, body: NoticeSettingUpsert) {
    return apiClient.put<NoticeSettingItem>(mgmtBase(municipalityId), body, { _silent: true })
  },
}
